import { LeftOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Spin } from 'antd';
import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE } from 'utils/common/const';

const leagues = [
  // { id: 1, name: 'WORLD CUP', logo: '/assets/images/logo/1.png' },
  { id: 2, name: 'UEFA Champions League', logo: '/assets/images/logo/2.webp' },
  { id: 3, name: 'UEFA Europa League', logo: '/assets/images/logo/3.webp' },
  { id: 4, name: 'English Premier League', logo: '/assets/images/logo/4.png' },
  { id: 5, name: 'Spanish La Liga', logo: '/assets/images/logo/5.png' },
  { id: 6, name: 'Italy Serie A', logo: '/assets/images/logo/6.png' },
  { id: 7, name: 'German Bundesliga', logo: '/assets/images/logo/7.webp' },
  { id: 8, name: 'France Ligue 1', logo: '/assets/images/logo/8.webp' },
  { id: 9, name: 'England FA Cup', logo: '/assets/images/logo/9.png' },
  { id: 10, name: 'Spain Supercopa de Espana', logo: '/assets/images/logo/10.webp' },
  { id: 13, name: 'International Friendly', logo: '/assets/images/logo/13.png' }
  // { id: 11, name: 'French Cup', logo: '/assets/images/logo/11.png' }
];

const QQ88Page = () => {
  const [isModalHistory, setIsModalHistory] = useState(false);
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow'
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();
  }, []);

  useEffect(() => {
    fetchDataScheduByLS();
    // Load saved account from localStorage
    const savedAccount = localStorage.getItem('saved_account');
    if (savedAccount) {
      form.setFieldsValue({ account: savedAccount });
    }
  }, [form]);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.QQ88
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.QQ88 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      console.log('filteredMatches', filteredMatches);
      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        // Lưu account vào localStorage
        if (data?.account) {
          localStorage.setItem('saved_account', data.account);
        }
        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined
          // sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      }
      // else if (scoreType === 'sameScore') {
      //   acc[matchId].sameScore = value;
      // }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          // match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          // match.sameScore !== null &&
          match.homeScore !== '' &&
          // match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          // sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>;
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find(
                  (league) =>
                    league.name === item.leagueName || item.leagueName.startsWith(league.name)
                )?.id
              )
            )
          : matchList;

      const itemMatch = filteredMatchList
        .filter((item) => timeServer <= item.countdown) // Filter out matches that have ended
        .map((item, index) => {
          // const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
          return (
            <div
              className={twMerge(
                'flex items-center max-w-[1200px] xl:w-3/4 md:w-4/5 w-full mx-auto bg-[#F1F1F1] rounded-2xl px-1 sm:px-2 pb-2 text-sm font-medium gap-2 border-solid border-6 border-[#006719] flex-col shadow-[0_0_10.574px_0_rgba(0,0,0,0.09)_inset] mt-3',
                timeServer > item.countdown ? 'contrast-50' : ''
              )}
              key={index}
            >
              <div
                className={twMerge(
                  'italic text-center min-w-[300px]',
                  'px-5 md:px-10 py-2 bg-gradient-to-b to-[#3DDB62] from-[#016719] border: 0.51px solid #006719; rounded-b-[16px]'
                )}
              >
                <p className="text-white text-center font-roboto font-bold leading-normal not-italic text-xs sm:text-sm md:text-base lg:text-lg">
                  {item?.leagueName}
                </p>
              </div>
              <div className="flex flex-row justify-center md:justify-center gap-1 md:gap-2 w-full items-center text-xs sm:text-sm md:text-base pb-3">
                <div className="flex flex-row items-center w-full md:w-[330px] h-[44px] md:h-[50px] justify-center">
                  <span
                    className="flex flex-row h-full justify-center items-center
                         px-[2px] md:px-4 py-[5px] gap-[2px]
                         text-[10px] sm:text-[12px] md:text-[14px]
                        
                        flex-none order-0 grow-0
                        w-full"
                  >
                    <span
                      className={`flex items-center justify-center h-full md:text-[14px] sm:text-[12px] text-[10px] ${
                        timeServer > item.countdown ? 'text-red-500' : 'text-black'
                      }`}
                    >
                      {timeServer > item.countdown ? 'Hết giờ' : 'Thời gian dự đoán còn: '}
                    </span>

                    <Countdown
                      date={item.countdown}
                      renderer={({ days, hours, minutes, seconds, completed }) => {
                        if (completed) {
                          return <span></span>;
                        } else {
                          const pad = (n) => n.toString().padStart(2, '0');
                          const totalHours = days * 24 + hours;
                          return (
                            <span className="text-[#016719] font-semibold">
                              {pad(totalHours)}:{pad(minutes)}:{pad(seconds)}
                            </span>
                          );
                        }
                      }}
                    />

                    {/* <Statistic.Countdown
                      value={item.countdown}
                      onFinish={onFinishCountDown}
                      className="text-[#0053DF] md:text-[14px] sm:text-[12px] text-[10px] ml-1 font-semibold flex items-center justify-center"
                    /> */}
                  </span>
                </div>
                <div className="flex flex-row items-center w-full md:w-[330px]  h-[44px] md:h-[50px] justify-center">
                  <span
                    className="flex flex-row h-full justify-center items-center
                        px-[2px] md:px-4 py-[5px] gap-[2px]
                        text-[10px] md:text-[14px] sm:text-[12px] 
                        flex-none order-0 grow-0
                        w-full"
                  >
                    <span className="flex items-center justify-center h-full ">
                      Thời gian kết thúc:{' '}
                    </span>
                    <span className="text-[#016719] ml-1 font-semibold flex items-center h-full justify-center">
                      {dayjs(item.startTime * 1000).format('HH:mm')}
                    </span>
                  </span>
                </div>
              </div>
              {/* <div className="rounded-t-[5.287px] bg-[linear-gradient(180deg,#254680_0%,#016719_54.9%,#2664d1_100%)] flex w-auto min-w-[180px] sm:w-[210px] h-[28px] sm:h-[32px] px-3 sm:px-4 py-1.5 sm:py-2 justify-center items-center shrink-0">
                <p className="text-white text-center text-xs sm:text-sm md:text-base font-semibold leading-normal whitespace-nowrap">
                  {`${matchDayOfWeek}, ${dayjs(item.startTime * 1000).format('DD/MM/YYYY')}`}
                </p>
              </div> */}
              <div className="flex flex-row item-center justify-center h-[70px] md:h-[90px] w-full xl:w-3/4 relative">
                <div
                  className="absolute w-[95%] h-[60%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 !z-0 bg-[#016719]
                                    border-[2px]
                                    shadow-[inset_0_0_20px_0_#0C2E68]
                                    rounded-lg"
                  style={{
                    borderImageSource: 'linear-gradient(0deg, #AEC8F5 0%, #FFFFFF 100%)',
                    borderImageSlice: 1
                  }}
                ></div>
                <div
                  className="z-[1] flex justify-center items-center w-full rounded-full bg-white shadow-[inset_0_0_5.43px_0_#00000040] 
                                    md:max-w-[90px] md:h-[90px] md:p-[5px]
                                    max-w-[60px] h-[60px] p-[2px]"
                  style={{ border: '1px solid #006719' }}
                >
                  <img src={item.homeLogo} className="w-[75%] h-full object-contain" alt="" />
                </div>

                <div className="text-xs sm:text-sm md:text-base font-medium flex justify-center items-center w-full h-full z-[1] text-white px-1">
                  {item.homeName}
                </div>

                <div className="flex flex-row items-center justify-center w-[60%] z-[1]">
                  <img
                    src="/assets/images/match/vs.png"
                    className="w-[100%] h-full object-contain"
                    alt=""
                  />
                </div>
                <div className="text-xs sm:text-sm md:text-base font-medium flex justify-center items-center w-full h-full z-[1] text-white px-1">
                  {item.awayName}
                </div>

                <div
                  className="z-[1] flex flex-col justify-center items-center w-full rounded-full bg-white shadow-[inset_0_0_5.43px_0_#00000040] 
                                    md:max-w-[90px] md:h-[90px] md:p-[5px]
                                    max-w-[60px] h-[60px] p-[2px]"
                  style={{ border: '1px solid #006719' }}
                >
                  <img src={item.awayLogo} className="w-[75%] h-full object-contain" alt="" />
                </div>
              </div>
              <div className="flex flex-col w-full sm:w-3/4 justify-center items-center px-2">
                <div className="flex md:justify-around justify-center flex-row items-center p-1 gap-3 sm:gap-5 md:gap-16">
                  <Form.Item className="m-0 p-0" name={`homeScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      max={99}
                      maxLength={2}
                      placeholder="Nhập số"
                      className="bg-white border-0 w-[70px] sm:w-[90px] md:w-[145px] h-[34px] sm:h-[37px] md:h-[40px] text-center text-xs sm:text-sm md:text-base font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] rounded-md"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                  <span className="font-bold text-black text-sm sm:text-base md:text-lg whitespace-nowrap px-1">
                    Tỉ số
                  </span>
                  <Form.Item className="m-0 p-0" name={`awayScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      max={99}
                      maxLength={2}
                      placeholder="Nhập số"
                      className="bg-white border-0 w-[70px] sm:w-[90px] md:w-[145px] h-[34px] sm:h-[37px] md:h-[40px] text-center text-xs sm:text-sm md:text-base font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] rounded-md"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                </div>
                {/* <div className="flex justify-between flex-row items-center p-1 gap-16">
                  <Form.Item className="m-0 p-0" name={`sameScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      maxLength={5}
                      placeholder="Số người dự đoán giống bạn"
                      className="bg-white border-0 !w-[290px] h-[37px] text-center text-[14.804px] font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)]"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                </div> */}
              </div>
              <div className="flex flex-row w-full sm:w-3/4 justify-center mt-2">
                <Button
                  type="none"
                  htmlType="submit"
                  className="
                    w-[140px] sm:w-[163px]
                    h-[38px] sm:h-[40px] md:h-[44px]
                    border-0 shadow-none bg-transparent hover:bg-transparent focus:bg-transparent hover:scale-105 transition-all duration-200"
                  style={{
                    backgroundImage: `url(assets/images/match/btn_send.png)`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                />
              </div>
              <div className="flex flex-row items-center w-full md:w-[330px] justify-center">
                <span
                  className="flex flex-row h-full justify-center items-center
                        px-2 gap-[3px]
                        text-black"
                >
                  <span className="flex items-center justify-center h-full md:text-[16px] text-[14px]">
                    Trước{' '}
                  </span>
                  <span className="text-[#016719] ml-1 font-semibold flex items-center h-full justify-center">
                    {dayjs(item.startTime * 1000).format('HH:mm')}
                  </span>
                  <span className="flex items-center justify-center h-full md:text-[16px] text-[14px]">
                    ngày{' '}
                  </span>
                  <span className="text-[#016719] ml-1 font-semibold flex items-center h-full justify-center">
                    {dayjs(item.startTime * 1000).format('DD/MM/YYYY')}
                  </span>
                </span>
              </div>
            </div>
          );
        });

      if (!itemMatch || itemMatch.length <= 0) {
        return <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>;
      }
      return itemMatch;
    }
  };

  return (
    <div className="w-full h-full flex flex-col">
      <img
        src={bg_home}
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover"
      />
      <div className="relative z-10">
        <HeaderMenu />
        <div className="mx-auto w-full md:pb-2 rounded-t-[34px]">
          <div className="w-full max-w-[1200px] mx-auto h-auto flex justify-center items-center">
            <img
              src="/assets/images/header/bannerpc.png"
              alt=""
              className="w-full h-auto object-contain md:flex hidden"
            />
            <img
              src="/assets/images/header/bannermb.png"
              alt=""
              className="w-full h-auto object-contain py-2 md:hidden flex"
            />
          </div>
          <div className="flex space-x-6 mt-4 justify-center items-center">
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={scrollLeft}
              className="text-[#006719] !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-custom pt-1 pb-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-black/15 shadow-lg shadow-[#006719] border-2 border-[#006719]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#006719]/30 hover:border-[#006719] hover:shadow-md'
                  )}
                  style={{ width: '80px', minWidth: '80px', border: '1px solid #006719' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={<RightOutlined />}
              onClick={scrollRight}
              className="text-[#006719] !px-0 !mx-0"
            />
          </div>
          <div className="w-full h-auto my-2 md:my-2">
            <div className="flex flex-wrap gap-1 sm:gap-3 lg:gap-5 items-center justify-center w-full">
              <button
                onClick={() => setActiveTab('all')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'all' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 outline-none focus:outline-none capitalize border-solid border-2 border-[#006719] ${
                  activeTab === 'all' ? 'bg-[#006719]' : 'bg-[#FFF]'
                }`}
              >
                Tất Cả
              </button>
              <button
                onClick={() => setActiveTab('today')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'today' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 border-solid border-2 border-[#006719] outline-none focus:outline-none capitalize ${
                  activeTab === 'today' ? 'bg-[#006719]' : 'bg-[#FFF]'
                }`}
              >
                Hôm Nay
              </button>
              <button
                onClick={() => setActiveTab('tomorrow')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'tomorrow' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 border-solid border-2 border-[#006719] outline-none focus:outline-none capitalize ${
                  activeTab === 'tomorrow' ? 'bg-[#006719]' : 'bg-[#FFF]'
                }`}
              >
                Ngày Mai
              </button>
              <button
                onClick={() => setShowSchedulePopup(true)}
                className="h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal text-[#FFF] transition-all duration-200 outline-none focus:outline-none capitalize bg-gradient-to-b bg-[#006719] hover:opacity-90 border-solid border-2 border-[#006719]"
              >
                Lịch Thi Đấu
              </button>
            </div>
          </div>
          <div className="w-full h-full">
            <Form
              name="formMatch"
              onFinish={onFinishForm}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              initialValues={{ account: '' }}
            >
              <div className="w-full h-full">
                {isLoading ? (
                  <div className="w-full h-full text-center py-8">
                    <Spin />
                  </div>
                ) : (
                  <div className="flex flex-col w-full h-full items-center mt-2">
                    <div className="flex w-full h-full items-center justify-center flex-col gap-2 md:mx-2 md:flex-row">
                      <div className="flex gap-2 md:py-4">
                        <Form.Item name="account" className="mb-0">
                          <Input
                            placeholder="Nhập tên đăng nhập ..."
                            maxLength={20}
                            prefix={<UserOutlined />}
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng điền tên đăng nhập!'
                              }
                            ]}
                            className="w-[200px] md:w-[250px] h-[40px] md:h-[44px] text-base" // Thêm classes này
                            style={{
                              fontSize: '16px'
                            }}
                          />
                        </Form.Item>
                        <Form.Item className="mb-0">
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={isLoadingSubmit}
                            className="text-white font-medium rounded-[4.286px] border-0 h-[36px] md:h-[40px]" // Điều chỉnh chiều cao button
                            style={{
                              background: '#006719'
                            }}
                          >
                            Xác Nhận
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="w-full h-full flex flex-col gap-2 mt-2">
                      {showListItemMatch(getFilteredMatches())}
                    </div>
                  </div>
                )}
                <div className="flex items-center justify-between mt-2"></div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {/* Popup Lịch Thi Đấu */}
      {showSchedulePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between p-4">
              <h2 className="text-xl font-bold text-[#  ]">LỊCH THI ĐẤU HOT</h2>
              <button
                onClick={() => setShowSchedulePopup(false)}
                className="w-8 h-8 bg-[#006719] text-white rounded-full flex items-center justify-center hover:bg-[#006719] transition-colors"
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <iframe
                src="https://football-widget.pages.dev/"
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title="Football Widget"
                className="w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default QQ88Page;
